import { Stack } from "@mui/material";
import { CustomerParty } from "Components/UserAccount/Customer/CustomerParty/CustomerParty";
import { DeactivateAccountButton } from "Components/UserAccount/Shared/DeactivateAccount/DeactivateAccountButton";
import { UserSettingsSection } from "Components/UserAccount/Shared/UserSettings/UserSettingsSection";
import { getPublicInformationTab } from "Components/UserAccount/Shared/PublicInformationTab";
import { VerificationForm } from "Components/UserAccount/Shared/VerificationForm/VerificationForm";
import {
  QueryParamTabs,
  type TabItem,
} from "Components/Shared/Tabs/QueryParamTabs";
import type { AccountDetailProps as Props } from "Components/UserAccount/types";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Components.Account;

export const CustomerUserAccountDetail = ({
  verification,
  canDeactivateAccount,
  party,
}: Props) => {
  const { t } = useResource();

  const tabs: Array<TabItem> = [
    getPublicInformationTab(t, party),
    {
      id: "account",
      label: t(COMPONENT_RESOURCES.AccountTab),
      content: (
        <Stack gap={2}>
          <PrimaryPaper>
            <UserSettingsSection />
          </PrimaryPaper>
          {canDeactivateAccount && (
            <PrimaryPaper>
              <DeactivateAccountButton />
            </PrimaryPaper>
          )}
        </Stack>
      ),
    },
    {
      id: "party",
      label: t(COMPONENT_RESOURCES.PersonalInformation),
      content: (
        <PrimaryPaper>
          <CustomerParty party={party} />
        </PrimaryPaper>
      ),
    },
    {
      id: "verification",
      label: t(COMPONENT_RESOURCES.Declaration),
      content: (
        <PrimaryPaper>
          <VerificationForm
            verification={verification}
            partyType={party.type}
          />
        </PrimaryPaper>
      ),
    },
  ];

  return <QueryParamTabs tabs={tabs} />;
};
